<template>
  <div>
    <AllowedMobileCountries :scope_id="scope_id"/>

    <AppSection
      id="sms-credentials"
      :title="$getConst.pages.sms_configuration.sms_settings_page_title"
      type="sub-section-1"
    >

      <b-overlay :show="isLoading">

        <template #overlay>
          <AppSpinner size="5" class="text-secondary"/>
        </template>

      <b-row>
        <b-col sm="12">
          <b-form-group id="template-language" :label="$t($getConst.pages.sms_configuration.sms_template_language_label)" label-for="template-language-input">
            <multiselect
              id="template-language-input"
              class="border-right-0 border-left-0"
              v-model="language"
              track-by="id"
              label="name"
              :placeholder="$t(this.$getConst.pages.form.select_option)"
              :options="languages"
              :allowEmpty="false"
              @select="selectTemplate"
            >
              <template slot="singleLabel" slot-scope="props">
                <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
                {{$t(props.option.name) | capitalize}}
              </template>
              <template slot="option" slot-scope="props">
                <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
                {{$t(props.option.name.toLowerCase()) | capitalize}}
              </template>
              <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group  id="ovh-sender" :label="$t($getConst.pages.ovh_credentials.ovh_sender_label) + ' *'" label-for="ovh-sender-input">
            <multiselect
              id="ovh-sender-input"
              class="border-right-0 border-left-0"
              v-model="$v.ovhSettingsToEdit.sender.$model"
              :placeholder="$t(this.$getConst.pages.form.select_option)"
              :options="senders"
              :allowEmpty="false"
            >
              <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group id="encoding" :label="$t($getConst.pages.ovh_credentials.ovh_encoding_label)" label-for="template-language-input">
            <multiselect
              id="encoding-input"
              class="border-right-0 border-left-0"
              v-model="$v.ovhSettingsToEdit.encoding.$model"
              :placeholder="$t(this.$getConst.pages.form.select_option)"
              :options="encodings"
              :allowEmpty="false"
            >
              <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
            </multiselect>
          </b-form-group>
        </b-col>

        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group id="ovh-class" :label="$t($getConst.pages.ovh_credentials.ovh_class_label)" label-for="ovh-class-input">
              <multiselect
                id="ovh-class-input"
                class="border-right-0 border-left-0"
                v-model="$v.ovhSettingsToEdit.ovhClass.$model"
                :placeholder="$t(this.$getConst.pages.form.select_option)"
                :options="classes"
                :allowEmpty="false"
              >
                <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-checkbox
              id="no-stop-clause"
              v-model="$v.ovhSettingsToEdit.noStopClause.$model"
              :disabled="isLoading"
              class="mt-4"
              name="sms"
              :value="1"
              :unchecked-value="0"
            >
              {{this.$t($getConst.pages.ovh_credentials.ovh_noStopClause_label)}}.
            </b-form-checkbox>
          </b-col>
        </b-row>

        <AppConfirmButtons
          v-if="hasWritePermission"
          :is-disabled="$v.ovhSettingsToEdit.$invalid"
          :is-loading="isLoading"
          @onSubmit="onSubmit"
          @onCancel="onCancel"
        />

      </b-overlay>
    </AppSection>

  </div>
</template>

<script>
  import AppSection from "../../../../../components/common/sections/AppSection";
  import AppSpinner from "../../../../../components/common/utils/AppSpinner";
  import {required} from "vuelidate/lib/validators";
  import AppFormFeedback from "../../../../../components/common/form/AppFormFeedback";
  import AppConfirmButtons from "../../../../../components/common/utils/AppConfirmButtons";
  import {getSmsSettingsByScope, updateSmsSettings, getSmsSender} from "../../../../../api/smsSettings.api";
  import AllowedMobileCountries from "./AllowedMobileCountries";

  export default {
    name: "index",
    components: {AllowedMobileCountries, AppConfirmButtons, AppFormFeedback, AppSpinner, AppSection},
    props: {
      scope_id: null
    },
    computed: {
      hasWritePermission() {
        return this.hasPermission(this.$getConst.permissions.writeSmsSettings)
      }
    },
    data() {
      return {
        isLoading: false,
        settings: [],
        languages: [],
        language: null,
        encodings: ['7bit','8bit'],
        classes: ['flash', 'phoneDisplay', 'sim', 'toolkit'],
        senders: [],
        ovhSettings: null,
        ovhSettingsToEdit: {
          id:null,
          sender: null,
          encoding: null,
          ovhClass: null,
          noStopClause: null
        },
      }
    },
    validations: {
      ovhSettingsToEdit: {
        sender: {required},
        encoding: {required},
        ovhClass: {required},
        noStopClause: {},
      }
    },
    methods: {
      getSmsSettings() {
        this.isLoading = true;
        getSmsSettingsByScope(this.scope_id).then(
          (response) => {
            this.settings = response.data;
            this.ovhSettings = Object.assign({}, response.data[0]);
            this.ovhSettingsToEdit = response.data[0];
            this.language = response.data[0].language;
            this.languages = [];
            this.settings.forEach(setting => {
              this.languages.push(setting.language);
            })
            this.isLoading = false;
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      },
      selectTemplate(language) {
        this.ovhSettingsToEdit = this.settings.find(template => template.language.id === language.id);
      },
      onSubmit() {
        this.isLoading = true;
        updateSmsSettings(this.scope_id, this.ovhSettingsToEdit.id, this.ovhSettingsToEdit).then(
          (response) => {
            this.ovhSettings = Object.assign({}, response.data);
            this.ovhSettingsToEdit = response.data;
            this.isLoading = false;
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      },
      onCancel() {
        this.ovhSettingsToEdit = Object.assign({}, this.ovhSettings);
      },
      getSmsSender() {
        getSmsSender(this.scope_id).then(
          (response) => {
            this.senders = response.data;
          },
            (error) => {
                this.handleApiError(error);
            }
        )
      }
    },
    created() {
      this.getSmsSettings();
      this.getSmsSender();
    },
  }
</script>

<style scoped>
  #ovh-application-secret-input {
    border-radius: 0 !important;
  }
  .border-radius {
    border-radius: 0.3rem !important;
  }
</style>
